var _g, _rect, _rect2, _rect3, _rect4, _mask, _rect5, _rect6, _rect7, _rect8, _rect9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcEmptyFeedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 305,
    height: 142,
    viewBox: "0 0 305 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.5 118.997H17.5C16.1193 118.997 15 120.116 15 121.497C15 122.878 16.1193 123.997 17.5 123.997H287.5C288.881 123.997 290 122.878 290 121.497C290 120.116 288.881 118.997 287.5 118.997Z",
    fill: "#ACACAC"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 102.5,
    y: 2.5,
    width: 99,
    height: 99,
    rx: 2.5,
    stroke: "#ACACAC",
    strokeWidth: 5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 19,
    width: 43,
    height: 7,
    rx: 3.5,
    fill: "#ACACAC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 19,
    width: 12,
    height: 7,
    rx: 3.5,
    fill: "#ACACAC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 19,
    width: 12,
    height: 7,
    rx: 3.5,
    fill: "#ACACAC"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 35,
    width: 43,
    height: 14,
    rx: 2
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 35,
    width: 43,
    height: 14,
    rx: 2,
    stroke: "#ACACAC",
    strokeWidth: 8,
    mask: "url(#path-6-inside-1)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 54,
    width: 65,
    height: 4,
    rx: 2,
    fill: "#ACACAC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 63,
    width: 45,
    height: 4,
    rx: 2,
    fill: "#ACACAC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 72,
    width: 70,
    height: 4,
    rx: 2,
    fill: "#ACACAC"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 81,
    width: 60,
    height: 4,
    rx: 2,
    fill: "#ACACAC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 106.997,
    width: 305,
    height: 35,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.059 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEmptyFeedIcon);
export default __webpack_public_path__ + "static/media/ic_empty_feed_icon.05cd58c7.svg";
export { ForwardRef as ReactComponent };